import { AlertTriangle, OctagonAlert } from "lucide-react";
import { useI18n } from "../lib/i18n";

export const CapacityAlert = ({ total, occupied, threshold = 80 }) => {
  const { t } = useI18n();
  if (!total || (occupied / total) * 100 < threshold) return null;
  const full = occupied >= total;
  const pct = Math.round((occupied / total) * 100);
  const Icon = full ? OctagonAlert : AlertTriangle;
  return (
    <div role="alert" data-testid="capacity-alert" data-level={full ? "full" : "warning"}
      className={`rise flex items-start gap-3 rounded-lg border-2 p-4 ${full ? "bg-rose-50 border-rose-400 text-rose-900" : "bg-amber-50 border-amber-400 text-amber-900"}`}>
      <Icon className="w-5 h-5 mt-0.5 shrink-0" />
      <div>
        <div className="font-extrabold">{full ? t("capacityFull") : t("capacityWarning")} · {pct}%</div>
        <div className="text-sm opacity-90">{t("capacityHint").replace("{free}", total - occupied).replace("{total}", total)}</div>
      </div>
    </div>
  );
};
